/**
 * Main dashboard page with admin-configurable widgets per team.
 * Widgets are dynamically loaded based on team dashboard configuration.
 */
import { useAuthStore } from "@/stores/auth";

/**
 * Main dashboard page
 *
 * Per user decision: Admin-configurable widgets per team.
 * Widgets are loaded based on team dashboard configuration.
 */
export function Dashboard() {
	const { activeTeam } = useAuthStore();

	return (
		<div className="p-6">
			<header className="mb-6">
				<h1 className="text-2xl font-bold">Dashboard</h1>
				<p className="text-muted-foreground">
					Welcome to {activeTeam?.name ?? "Unios"}
				</p>
			</header>

			{/* Widget Grid */}
			<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
				{/* Placeholder widgets - will be replaced with react-grid-layout */}
				<div className="rounded-lg border bg-card p-4">
					<h3 className="text-sm font-medium text-muted-foreground">
						Total Impressions
					</h3>
					<p className="text-2xl font-bold">-</p>
				</div>
				<div className="rounded-lg border bg-card p-4">
					<h3 className="text-sm font-medium text-muted-foreground">
						Total Clicks
					</h3>
					<p className="text-2xl font-bold">-</p>
				</div>
				<div className="rounded-lg border bg-card p-4">
					<h3 className="text-sm font-medium text-muted-foreground">
						Total Spend
					</h3>
					<p className="text-2xl font-bold">-</p>
				</div>
				<div className="rounded-lg border bg-card p-4">
					<h3 className="text-sm font-medium text-muted-foreground">
						Active Campaigns
					</h3>
					<p className="text-2xl font-bold">-</p>
				</div>
			</div>

			{/* TODO: Implement full widget grid with react-grid-layout */}
			<div className="mt-6 rounded-lg border border-dashed p-12 text-center text-muted-foreground">
				Dashboard widgets will be configurable per team.
				<br />
				Use the admin panel to configure widget layout.
			</div>
		</div>
	);
}
